import React from "react";
import styled from "styled-components";
import { Box, Flex } from "reflexbox/styled-components";
import homeSvg from "../assets/images/home.svg";
import panelsSvg from "../assets/images/panels.svg";
import speakersSvg from "../assets/images/speakers.svg";
import locationSvg from "../assets/images/location.svg";
import sponsorsSvg from "../assets/images/sponsors.svg";
import { withLocalizeStrings } from "../languages/Localize";
import { NavLink, useHistory } from "react-router-dom";
import routes from "../config/routes";

const StyledNavigation = styled(Flex)`
    position: fixed;
    bottom: 0;
    width: 100%;
    height: 56px;
    z-index: 10;
    border-top: 1px solid ${({ theme }) => theme.colors.primary};
`;
const StyledNavigationItem = styled(NavLink)`
    width: 100%;
    box-sizing: border-box;
    display: flex;
    height: 100%;
    border: 1px solid ${({ theme }) => theme.colors.borders};
    border-bottom: 4px solid transparent;
    border-top: 7px solid transparent;
    flex-direction: column;
    text-decoration: none;
    vertical-align: top;
    text-align: center;
    color: ${({ theme }) => theme.colors.primary};
    justify-content: center;
    align-items: center;
    font-size: ${({ theme }) => theme.fontSizes[0]}px;
    user-select: none;

    &:hover,
    &:active,
    &.active {
        border-bottom: 4px solid ${({ theme }) => theme.colors.primary};

        margin-bottom: 0;
        color: ${({ theme }) => theme.colors.primary};
    }
`;

const StyledIcon = styled(Box)`
    height: 35px;
    width: 35px;
    &.home {
        background: url(${homeSvg}) no-repeat center;
        background-size: 35px 35px;
    }
    &.panels {
        background: url(${panelsSvg}) no-repeat center;
        background-size: 35px 35px;
    }
    &.speakers {
        background: url(${speakersSvg}) no-repeat center;
        background-size: 35px 35px;
    }
    &.location {
        background: url(${locationSvg}) no-repeat center;
        background-size: 35px 35px;
    }
    &.sponsors {
        background: url(${sponsorsSvg}) no-repeat center;
        background-size: 35px 35px;
    }
`;

const Menu = ({ strings }) => {
    const { pathname: path } = useHistory();
    return (
        <StyledNavigation bg="white" path={path}>
            <StyledNavigationItem to={routes.HOME} exact>
                <StyledIcon className="home" />
                {strings.menu.HOME}
            </StyledNavigationItem>
            <StyledNavigationItem to={routes.PANELS}>
                <StyledIcon className="panels" />
                {strings.menu.PANELS}
            </StyledNavigationItem>
            <StyledNavigationItem to={routes.SPEAKERS}>
                <StyledIcon className="speakers" />
                {strings.menu.SPEAKERS}
            </StyledNavigationItem>
            <StyledNavigationItem to={routes.SPONSORS}>
                <StyledIcon className="sponsors" />
                {strings.menu.SPONSORS}
            </StyledNavigationItem>
            <StyledNavigationItem to={routes.LOCATION}>
                <StyledIcon className="location" />
                {strings.menu.LOCATION}
            </StyledNavigationItem>
        </StyledNavigation>
    );
};

export default withLocalizeStrings(Menu);
